
namespace TabAurous.Reports {

     
    export var finid = [];
    export var companyids = [];
    export var vendorids = [];
    export var baseitemid = [];
    export var typeids = [];
    export var subtypeids = [];
    export var applyfilter = false;
    import fld = Sales.SalesMasterRow.Fields;
    @Serenity.Decorators.registerClass()
    export class CustomerSalesGrid extends Serenity.EntityGrid<TabAurous.Sales.SalesMasterRow, any> {
        protected getColumnsKey() { return 'Sales.CustomerSales'; }
        protected getDialogType() { return TabAurous.Sales.SalesMasterDialog; }
        protected getIdProperty() { return TabAurous.Sales.SalesMasterRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Sales.SalesMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Sales.SalesMasterRow.localTextPrefix; }
        protected getService() { return TabAurous.Sales.CustomerSalesService.baseUrl; }
      
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
             
            this.addQuickFilter({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        finid = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                    w.active = false;
                    w.handled = true;
                    return false;
                },

                cssClass: 'hidden-xs'

            });
            this.addQuickFilter({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        companyids = temp;
                    }
                    w.active = false;
                    w.handled = true;
                    return false;
                },

                cssClass: 'hidden-xs'

            });

            //this.addDateRangeFilter("TransDate", "Date");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            
            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('GrossAmount'),
                    new Slick.Aggregators.Sum('NetAmount')
                ]
            });

            this.view.setGrouping([{ getter: 'LedgerName' }]);

            return grid;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
        //protected getColumns() {
        //    var columns = super.getColumns();

        //    Q.first(columns, x => x.field === 'GrossAmount')
        //        .groupTotalsFormatter = (totals, col) =>
        //            (totals.sum ? ('sum: ' + Q.coalesce(totals.sum[col.field],'')) : '');

        //    return columns;
        //}
        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Sales/CustomerSales/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Customer',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push((values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });

            return filters;
        }
        
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({
            //    title: 'Print Register',
            //    cssClass: 'export-pdf-button',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.ApprovalRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //)
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Customer Sales",
                onViewSubmit: () => this.onViewSubmit()
            }))
                ,
                ({
                title: 'Apply Filter',
                cssClass: '',
                icon: 'fa-filter',
                onClick: () => {
                    applyfilter = true;
                    if (companyids.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = companyids;

                    } if (finid.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = finid;
                    } if (vendorids.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = vendorids;
                    }
                    Sales.CustomerSalesService.List({ VendorIds: vendorids }, response => {
                        this.setItems(response.Entities);
                        this.refresh();
                    }, { async: false, blockUI: true });


                }

                });
            return buttons;
        }
    }
    

  

}